module.exports = __webpack_public_path__ + "img/img-works_6.c6ced861.png";